import { useSelector } from "react-redux";
import { routeConstant } from "shared/routes/routeConstant";
import ProjectsList from "shared/components/dashboardCommon/projectsList";

const DesignerArchivedProjects = () => {
  const auth = useSelector((state: any) => state.root.auth);

  return (
    <ProjectsList
      userType="designer"
      pageTitle={`${auth?.user?.display_name || "Sarah"}'s Archived Projects`}
      pageDescription="Projects you've archived — contact an admin to bring them back."
      showSearchFilter={true}
      EnableApiIntegration={true}
      noContentMessage="No archived projects yet. Archive a project from your active projects list."
      detailRoutePath={routeConstant.designer.projectDetail.path}
      isArchived={true}
      showArchiveButton={true}
    />
  );
};

export default DesignerArchivedProjects;
